module.exports = __webpack_public_path__ + "img/StrengthTrainingEquipment.addce0b6.png";